var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0.366486H2C0.89 0.366486 0.00999999 1.25649 0.00999999 2.36649L0 14.3665C0 15.4765 0.89 16.3665 2 16.3665H18C19.11 16.3665 20 15.4765 20 14.3665V2.36649C20 1.25649 19.11 0.366486 18 0.366486ZM18 14.3665H2V8.36649H18V14.3665ZM18 4.36649H2V2.36649H18V4.36649Z",
    fill: "#219A97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardIcon);
export default __webpack_public_path__ + "static/media/creditCardIcon.1a1f992378b46fadabb4b49d3adf8ce8.svg";
export { ForwardRef as ReactComponent };